
export const MODIFIER_ID = {
    ESSENCE_VOP: "67c8edf6-c746-4826-b912-2a780063e255",
}
